module.exports = __webpack_public_path__ + "static/media/postres_alt.db102714.jpg";